import { BlurTint } from 'expo-blur';
import { FC, ReactNode, createContext, memo } from 'react';
import { LayoutRectangle } from 'react-native';
import { DropdownBackdropMode, DropdownComponentStyles } from './types';

type Props = {
  boundingRect?: LayoutRectangle;
  placeholderTextColor?: string;
  searchInputPlaceholderTextColor?: string;
  componentStyles?: DropdownComponentStyles;
  backdropMode?: DropdownBackdropMode;
  backdropBlurTint?: BlurTint;
  backdropBlurIntensity?: number;
};

// use this context o restrict the dropdown to the give bounds
// by default the window viewport will be used.
export const DropdownContext = createContext<Props | undefined>(undefined);

export const DropdownProvider: FC<
  Props & {
    children?: ReactNode;
  }
> = memo(({ children, ...value }) => {
  return (
    <DropdownContext.Provider value={value}>
      {children}
    </DropdownContext.Provider>
  );
});
